module.exports = __webpack_public_path__ + "static/bryan-ruef-3-93df700d83db3a086e903b2c19b5e926.jpg";